// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[0]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].rules[0].oneOf[1].use[1]!../../../../node_modules/ckeditor5/dist/ckeditor5.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Oswald&family=PT+Serif:ital,wght@0,400;0,700;1,400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

h2 {
  font-size: 24px;
}

body {
  font-size: 13px;
}

.list-title {
  font-size: 15px;
  font-weight: 700;
  color: #333;
  padding: 16px;
  margin-top: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
  margin-bottom: 10px;
}

.fixed-loader {
  width: 100%;
  height: 100%;
  text-align: center;
}
.fixed-loader i {
  font-size: 8em !important;
}

.list-items {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  padding: 0 10px 6px;
}

.list {
  flex: 0 0 27rem;
  display: flex;
  flex-direction: column;
  background-color: #e2e4e6;
  border-radius: 4px;
  position: relative;
}
.list div#move-member {
  position: absolute;
  top: 0;
  right: 0;
}

.list-items li {
  font-size: 15px;
  font-weight: 400;
  line-height: 1.3;
  background-color: #fff;
  padding: 10px 9px;
  color: #4d4d4d;
  border-bottom: 2px solid #ccc;
  border-radius: 4px;
  margin-bottom: 9px;
  word-wrap: break-word;
  cursor: pointer;
}

.list-columns {
  display: flex;
}
.list-columns div {
  cursor: pointer;
}

.table-responsive {
  overflow: auto;
}
.table-responsive--height {
  height: 100vh;
}

.p-l-25 {
  padding-left: 25px;
}

.add-card-btn {
  padding-top: 10px;
}
.add-card-btn span {
  padding-left: 10px;
}

.update-card-btn {
  margin-left: auto;
  margin-bottom: 16px;
  padding-left: 10px;
}
.update-card-btn a {
  margin-left: 20px;
  color: #fff;
}

.button-link {
  background-color: #ebecf0;
  box-shadow: 0 1px 0 0 rgba(9, 30, 66, 0.13);
  border: none;
  border-radius: 3px;
  display: block;
  font-weight: 700;
  height: 32px;
  margin-top: 8px;
  max-width: 300px;
  padding: 3px 12px;
}

.title-icon {
  content: "\\e968";
}

.list-columns div[class*=col-] {
  padding-left: 5px;
  padding-right: 5px;
}

.option-menu {
  position: relative;
}
.option-menu .list-action-dropdown {
  position: absolute;
  right: 0;
  top: 0;
}

.column-edit {
  cursor: pointer;
  padding: 6px 12px;
  border: 1px solid transparent;
  display: inline-block;
}
.column-edit::before {
  content: "\\f142";
  font: normal normal normal 14px/1 FontAwesome;
  font-size: 15px;
  color: #b7b7b7;
  line-height: 3px;
  cursor: pointer;
}
.column-edit.dropdown {
  cursor: pointer;
}
.column-edit.dropdown:hover .dropdown__list {
  display: block;
}

.quick-card-editor-buttons .subgroup-move {
  display: block;
  position: absolute;
  right: 5px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 5px;
  z-index: 99;
  display: none;
  top: 0;
}
.quick-card-editor-buttons .subgroup-move .subgroup-inner {
  background: #fff;
  position: absolute;
  right: 0;
  border-radius: 4px;
  top: 100%;
  min-width: 150px;
  box-shadow: 1px 10px 29px rgba(0, 0, 0, 0.1);
  top: 28px;
}

.close-action {
  cursor: pointer;
  color: #212529;
}

.card-title {
  color: #333;
  font-size: 16px;
  margin-bottom: 10px;
}

.column-actions {
  border-bottom: 1px solid rgba(9, 30, 66, 0.13);
  font-size: 16px;
}

.list-actions button {
  font-size: 13px;
  border: none;
  padding: 6px 12px;
  cursor: pointer;
}
.list-actions button.modify {
  cursor: pointer;
  background-color: transparent;
  border-top: 1px solid #e7eaec;
  border-radius: unset;
  padding-inline: 20px;
  color: #676a6c;
  font-weight: 600;
  width: 100%;
  text-align: left;
}
.list-actions button.modify:hover {
  color: #4cae4c;
}
.list-actions button.modify--red {
  color: #ff485c;
}
.list-actions button.modify--red:hover {
  color: #ff485c;
}

.image-imitation {
  min-height: 400px;
  background-size: contain !important;
  background-position: center;
}

.ibox-content.pos-relative {
  padding: 30px;
}

::ng-deep.modal-module .modal-dialog {
  max-width: 1170px;
  width: 100%;
}

::ng-deep.ngx-datepicker-container .ngx-datepicker-calendar-container {
  z-index: 9;
}

::ng-deep.ngx-datepicker-input {
  background-color: #fff !important;
  width: 100% !important;
}

.card-actions a {
  display: inline;
}

.action-icons {
  padding: 0px;
}

.session-btn {
  display: flex;
}
.session-btn a {
  padding: 5px;
  width: 26px;
  color: #fff;
}

.top-session-grid {
  margin: 10px 0;
}

.form-control {
  border: 1px solid #7b7b7b;
  border-radius: 4px;
  font: inherit;
  min-height: 34px;
}
.form-control__disabled {
  pointer-events: none;
  opacity: 0.6;
}
.form-control:focus-visible, .form-control:focus {
  outline: none;
}

.card-actions a {
  color: #fff;
}

.custom-modal-footer {
  justify-content: flex-start;
}
.custom-modal-footer .form-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.custom-modal-footer .form-group label {
  padding: 0;
  width: auto;
}

.add-card-btn.btn {
  background: transparent;
  border: 1px solid transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.list-columns .input-group {
  display: flex;
  width: 100%;
}
.list-columns .input-group .f-btn {
  height: 100%;
  min-width: 91.55px;
  font-size: 14px;
}

hr {
  margin-top: 20px;
  margin-bottom: 20px !important;
  border: 0;
  border-top: 1px solid #eeeeee;
}

.mt-3.btn-primary {
  margin-top: 10px;
}

.col-sm-3 {
  flex: 0 0 290px;
  max-width: 290px;
}

.modal-title {
  display: inline-block;
  font-size: 20px;
  color: #212529;
  font-weight: 500;
}

.modal-header .close {
  opacity: 1;
}

.modal-header .close .btn {
  font-size: 14px;
  margin: 1px;
}
.modal-header .close .btn-warning {
  margin: 10px;
}

.modal-footer {
  border-top: 1px solid #ddd;
}

.modal-footer.custom-modal-footer {
  display: flex;
  flex-wrap: wrap;
}

.modal-footer.custom-modal-footer:before,
.modal-footer.custom-modal-footer:after {
  display: none;
}

.modal-footer.custom-modal-footer h2 {
  font-weight: 500;
  color: #6c757d !important;
  margin-bottom: 8px;
}

@media (max-width: 767px) {
  .modal-footer .form-group {
    padding-left: 0px;
    width: 100%;
    text-align: left;
  }
}

.modal-copy h3 {
  font-size: 24px;
  color: #333;
  font-weight: 500;
  margin-left: -15px;
  margin-right: -15px;
}
.modal-copy .btn-primary {
  margin-top: 15px;
}

.card-body + .card-body .card-title {
  margin-top: 15px;
}

::ng-deep.single-card-link span {
  display: block;
  font-size: 65%;
  text-transform: uppercase;
  padding-top: 8px;
}

::ng-deep.list-group-item--inactive {
  background-color: #ccc !important;
}
::ng-deep.list-group-item span {
  display: none;
}
::ng-deep.list-group-item div {
  font-size: 11px;
  display: block;
}

::ng-deep.swal2-modal {
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
}

::ng-deep .swal2-show {
  background-color: white;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  width: 478px;
  padding: 17px;
  border-radius: 5px;
  text-align: center;
  position: fixed;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  -webkit-transform: translate(0, 0) !important;
  -moz-transform: translate(0, 0) !important;
  margin-left: -256px;
  overflow: hidden;
  z-index: 99999;
  margin-top: -168px;
}
::ng-deep .swal2-show:focus {
  outline: none;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled {
  background-color: #28a745 !important;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-cancel.swal2-styled:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.5);
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled {
  background-color: #dc3545;
  color: white;
  border: none;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 26px 5px 0 5px;
  cursor: pointer;
}
::ng-deep .swal2-show button.swal2-confirm.swal2-styled:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(220, 53, 58, 0.5);
}
::ng-deep .swal2-show .swal2-icon.swal2-warning {
  width: 80px;
  height: 80px;
  border: 4px solid gray;
  border-radius: 40px;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
  border-color: #F8BB86;
  font-size: 58px;
  color: #F8BB86;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
}
::ng-deep .swal2-show .swal2-icon.swal2-warning:focus {
  outline: none;
  box-shadow: 0 0 0 3px #F8BB86;
}
::ng-deep .swal2-show h2#swal2-title {
  color: #575757;
  font-size: 30px;
  text-align: center;
  font-weight: 600;
  text-transform: none;
  position: relative;
  margin: 25px 0;
  padding: 0;
  line-height: 40px;
  display: block;
}
::ng-deep .swal2-show h2#swal2-title:focus {
  outline: none;
  box-shadow: 0 0 0 3px #575757;
}
::ng-deep .swal2-show div#swal2-content {
  color: #797979;
  font-size: 16px;
  text-align: center;
  font-weight: 300;
  position: relative;
  text-align: inherit;
  float: none;
  margin: 0;
  padding: 0;
  line-height: normal;
}
::ng-deep .swal2-show div#swal2-content:focus {
  outline: none;
  box-shadow: 0 0 0 3px #797979;
}

.swal2-show button.swal2-cancel.swal2-styled:focus {
  opacity: 1;
  box-shadow: 0 0 0 3px rgba(208, 208, 208, 0.5);
}

::ng-deep .swal2-shown {
  background-color: black;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999999999999;
}

::ng-deep.swal2-modal {
  max-width: 500px !important;
  width: 100% !important;
  left: 0 !important;
  top: 0 !important;
  transform: translate(0, 0) !important;
  -webkit-transform: translate(0, 0) !important;
  -moz-transform: translate(0, 0) !important;
  margin-left: 0 !important;
  margin-top: 0 !important;
  box-sizing: border-box !important;
  bottom: 0;
  right: 0;
  margin: auto !important;
  height: 390px;
}

.modal-body .ibox-title {
  padding-left: 0;
  border: none;
  padding-top: 0;
}
.modal-body .ibox-title h5 {
  font-size: 17px;
  font-weight: 500;
}
.modal-body .btn.btn-primary {
  margin-top: 18px;
}

.edit-lm {
  margin-top: 25px;
}
.edit-lm a {
  margin-right: 10px;
}

.card-active {
  text-transform: capitalize;
}

.video-info {
  padding: 15px;
  margin-top: 40px;
}

.edit-card__right .col-md-9 {
  width: 85%;
}
.edit-card__btm {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: 25px;
  flex-direction: column-reverse;
}
.edit-card__btm .editor-script {
  width: 100%;
}
.edit-card__btm .editor-script--spc {
  margin-bottom: 15px;
  display: none;
}
.edit-card__btm .editor-script--spc .editor-script {
  margin-top: 25px;
}
.edit-card__btm .editor-script--visible {
  display: block;
}
.edit-card__btm .editor-script--visible label {
  padding: 0;
  width: 100%;
}
.edit-card__btm .editor-script--visible label i {
  cursor: pointer;
}

.feature-grp {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.middle-grid .cdkeditmode {
  display: block;
}
.middle-grid--show-editor .cdkeditmode {
  display: none;
}

.cdk-drag-outer {
  flex: 0 0 225px;
  max-width: 225px;
  float: none;
}

::ng-deep bs-datepicker#first-train, ::ng-deep bs-datepicker#last-train {
  border: 1px solid #7b7b7b;
  border-radius: 4px;
  padding: 6px 12px;
}
::ng-deep bs-datepicker#first-train .datepicker-container, ::ng-deep bs-datepicker#last-train .datepicker-container {
  width: 94%;
  padding-top: 7px;
}
::ng-deep bs-datepicker#first-train input, ::ng-deep bs-datepicker#last-train input {
  border: 0;
  font-family: "Open Sans";
  color: #676a6c;
  font-size: 14px;
}

::ng-deep .modal {
  inset: 0;
  outline: 0;
  z-index: 1050;
  display: none;
  position: fixed;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}
::ng-deep .modal .modal-dialog {
  width: 100%;
  padding: 0 15px;
  max-width: 1200px;
  margin: 30px auto;
}
::ng-deep .modal .modal-dialog .modal-content .modal-header {
  border-bottom: 1px solid #e5e5e5;
}
::ng-deep .modal .modal-dialog .modal-content .modal-header .modal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.5;
  color: #212529;
  display: inline-block;
}
@media (max-width: 767px) {
  ::ng-deep .modal .modal-dialog .modal-content .modal-header .modal-title {
    margin-bottom: 15px;
  }
}
::ng-deep .modal .modal-dialog .modal-content .modal-header .close {
  opacity: 1;
  font-size: 21px;
  text-shadow: 0 1px 0 #fff;
}
::ng-deep .modal .modal-dialog .modal-content .modal-header .close .actn__btn {
  width: 35px;
  height: 32px;
  padding: 3px;
}
@media (max-width: 767px) {
  ::ng-deep .modal .modal-dialog .modal-content .modal-header .close .actn {
    justify-content: flex-start;
  }
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .close {
  float: right;
  border: none;
  opacity: 0.2;
  color: #000;
  line-height: 1;
  font-size: 21px;
  font-weight: bold;
  background-color: #fff;
  filter: alpha(opacity=20);
  text-shadow: 0 1px 0 #fff;
  cursor: pointer;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .close:focus-visible {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .close:hover {
  opacity: 0.5;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .close.button {
  border: 0;
  padding: 0;
  cursor: pointer;
  appearance: none;
  background: transparent;
  -webkit-appearance: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .small {
  font-size: 12px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .small a:focus-visible {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body.modal-copy h3 {
  color: #333;
  font-size: 24px;
  font-weight: 500;
  margin-left: -15px;
  margin-right: -15px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body.modal-copy .card-body {
  width: 100%;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .top-form .edit-card__top .media-content h2 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 5px;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .top-form .edit-card__top .media-content h2 small {
  font-size: 16px;
  font-weight: normal;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .top-form .edit-card__top .media-content .single-card-link {
  cursor: pointer;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body .ibox-title {
  border: none;
  padding-top: 0;
  padding-left: 0;
}
@media (max-width: 767px) {
  ::ng-deep .modal .modal-dialog .modal-content .modal-body form .rw__cl:not(:last-child) {
    margin-bottom: 15px;
  }
}
@media (max-width: 767px) {
  ::ng-deep .modal .modal-dialog .modal-content .modal-body form .rw__cl:not(:last-child) .rw-lvl-2__cl:not(:last-child) {
    margin-bottom: 15px;
  }
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form .form-group {
  margin-bottom: 0;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form .form-group label {
  max-width: 100%;
  font-weight: 700;
  display: inline-block;
}
::ng-deep .modal .modal-dialog .modal-content .modal-footer {
  text-align: left;
  border-top: 1px solid #e5e5e5;
}
::ng-deep .modal .modal-dialog .modal-content .modal-footer__cntnt .form-group {
  margin-bottom: 0;
}
::ng-deep .modal .modal-dialog .modal-content .modal-footer__cntnt .form-group h2 {
  margin-bottom: 20px;
  font-weight: 500;
  color: #6c757d !important;
}
@media (max-width: 1200px) {
  ::ng-deep .modal .modal-dialog .modal-content .modal-footer__cntnt .form-group h2 {
    font-size: 16px;
    margin-block: 12px;
  }
}
@media (max-width: 991px) {
  ::ng-deep .modal .modal-dialog .modal-content .modal-footer__cntnt .form-group h2 {
    margin-block: 0;
  }
}
@media (max-width: 991px) {
  ::ng-deep .modal .modal-dialog .modal-content .modal-footer__cntnt > * {
    width: 100%;
  }
}
@media (max-width: 991px) {
  ::ng-deep .modal .modal-dialog .modal-content .modal-footer__cntnt > *:not(:last-child) {
    margin-bottom: 15px;
  }
}
@media (max-width: 991px) {
  ::ng-deep .modal .modal-dialog .modal-content .modal-footer__cntnt {
    flex-direction: column;
    align-items: flex-start;
  }
}
::ng-deep .modal .modal-dialog.modal-sm {
  max-width: 300px;
}
::ng-deep .modal .modal-dialog.modal-lg {
  max-width: 900px;
}
::ng-deep .modalParent.grey {
  background-color: rgba(236, 236, 236, 0.9);
}
::ng-deep .modal .f-btn {
  color: #fff;
  font-size: 14px;
  border-color: #73BF38;
  background-color: #73BF38;
}
::ng-deep .modal .f-btn:hover {
  border-color: #4cae4c;
  background-color: #4cae4c;
}
::ng-deep .modal .f-btn--dngr {
  color: #fff;
  border-color: #ED5565;
  background-color: #ED5565;
}
::ng-deep .modal .f-btn--dngr:hover {
  border-color: #ec4758;
  background-color: #ec4758;
}
::ng-deep .modal .f-btn--info {
  color: #fff;
  border-color: #23c6c8;
  background-color: #23c6c8;
}
::ng-deep .modal .f-btn--info:hover {
  border-color: #21b9bb;
  background-color: #21b9bb;
}
::ng-deep .modal .f-btn--wrng {
  color: #fff;
  border-color: #f8ac59;
  background-color: #f8ac59;
}
::ng-deep .modal .f-btn--wrng:hover {
  border-color: #f7a54a;
  background-color: #f7a54a;
}
::ng-deep .modal.fade {
  opacity: 0;
  transition: opacity 0.15s linear;
}
::ng-deep .modal.fade.in {
  opacity: 1;
}
::ng-deep .modal.show {
  display: block !important;
}
::ng-deep .modal.modal-open {
  overflow-y: auto;
  overflow-x: hidden;
}
::ng-deep .modal.grey {
  background: rgba(236, 236, 236, 0.9);
}

::ng-deep .swal2-container {
  z-index: 9999999999;
}

.fade {
  opacity: 0;
  transition: opacity 0.15s linear;
}

.modal {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}

.show {
  display: block !important;
}

.modal {
  z-index: 2050 !important;
}

.modal {
  z-index: 20509999999 !important;
}

.fade.in {
  opacity: 1;
}

::ng-deep body.modal-open {
  overflow: hidden;
}
::ng-deep body.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal-backdrop {
  z-index: 2040 !important;
  position: fixed;
  inset: 0;
  background-color: #000;
}
.modal-backdrop.fade {
  filter: alpha(opacity=0);
  opacity: 0;
}

.dialogbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(236, 236, 236, 0.9);
  z-index: 99999;
}
.dialogbox__wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 30px;
}
.dialogbox__inner {
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.dialogbox__inner[data-width=small] {
  width: min(1090px, 100%);
}
.dialogbox__inner[data-width=medium] {
  width: min(1198px, 100%);
}
.dialogbox__inner--wd[data-width=small] {
  width: min(770px, 100%);
}
.dialogbox__inner--wd[data-width=medium] {
  width: min(870px, 100%);
}
.dialogbox__inner--clwid[data-width=small] {
  width: min(170px, 100%);
}
.dialogbox__inner--clwid[data-width=medium] {
  width: min(270px, 100%);
}
.dialogbox__hdr {
  padding: 15px 30px;
  border-bottom: 1px solid #ddd;
  position: relative;
}
.dialogbox__hdr h2 {
  font-size: 17px;
  line-height: 1.3;
  font-weight: 400;
}
.dialogbox__ftr {
  border-top: 1px solid #ddd;
}
.dialogbox .dialogbox__steps :is(ul, ol):last-child {
  margin-bottom: 0;
}
.dialogbox .dialogbox__steps li {
  font-size: 12px;
}
.dialogbox__smalllabel {
  font-size: 12px;
  font-weight: 400;
}
.dialogbox label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 15px;
  font-weight: 700;
  margin-top: 0;
}
.dialogbox label:last-child {
  margin-bottom: 0;
}
.dialogbox select,
.dialogbox input[type=text] {
  height: 35px;
  padding: 3px 10px;
  width: 100%;
  background-color: #fff;
  border: 1px solid #ddd;
}
.dialogbox select:focus,
.dialogbox input[type=text]:focus {
  outline: none;
}
.dialogbox input[type=radio] {
  margin: 0 5px 0 0;
  position: relative;
  top: 2px;
}
.dialogbox__dpsteps {
  counter-reset: section;
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.dialogbox__dpsteps-hdr::before {
  counter-increment: section;
  content: counters(section, ".") ". ";
  font-weight: 700;
}
.dialogbox__close {
  --cSize: 16px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
  width: var(--cSize);
  height: var(--cSize);
  padding: 0;
  border: 0;
  background-color: transparent;
  opacity: 0.2;
  transition: 0.3s;
  cursor: pointer;
}
.dialogbox__close:hover {
  opacity: 0.4;
}
.dialogbox__close::before, .dialogbox__close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 2px;
  height: 100%;
  background-color: #000;
  border-radius: 2px;
}
.dialogbox__close::after {
  transform: translate(-50%, -50%) rotate(45deg);
}

::ng-deep.NgxEditor__MenuBar {
  border: 1px solid #e7eaec;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

::ng-deep.NgxEditor {
  min-height: 200px;
  border-radius: 0 !important;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top: 0 !important;
  border-color: #e7eaec !important;
}

::ng-deep bs-datepicker-container {
  z-index: 999999;
}

::ng-deep code {
  white-space: normal;
}

.wrd-break {
  word-wrap: break-word;
}

.ckeditor_5 ::ng-deep.main-container {
  font-family: "Lato";
  width: -moz-fit-content;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}
.ckeditor_5 ::ng-deep.ck-content {
  font-family: "Lato";
  line-height: 1.6;
  word-break: break-word;
}
.ckeditor_5 ::ng-deep.editor-container_classic-editor .editor-container__editor {
  min-width: 795px;
  max-width: 795px;
}
.ckeditor_5 ::ng-deep.ck-content h3.category {
  font-family: "Oswald";
  font-size: 20px;
  font-weight: bold;
  color: #555;
  letter-spacing: 10px;
  margin: 0;
  padding: 0;
}
.ckeditor_5 ::ng-deep.ck-content h2.document-title {
  font-family: "Oswald";
  font-size: 50px;
  font-weight: bold;
  margin: 0;
  padding: 0;
  border: 0;
}
.ckeditor_5 ::ng-deep.ck-content h3.document-subtitle {
  font-family: "Oswald";
  font-size: 20px;
  color: #555;
  margin: 0 0 1em;
  font-weight: bold;
  padding: 0;
}
.ckeditor_5 ::ng-deep.ck-content p.info-box {
  --background-size: 30px;
  --background-color: #e91e63;
  padding: 1.2em 2em;
  border: 1px solid var(--background-color);
  background: linear-gradient(135deg, var(--background-color) 0%, var(--background-color) var(--background-size), transparent var(--background-size)), linear-gradient(135deg, transparent calc(100% - var(--background-size)), var(--background-color) calc(100% - var(--background-size)), var(--background-color));
  border-radius: 10px;
  margin: 1.5em 2em;
  box-shadow: 5px 5px 0 #ffe6ef;
}
.ckeditor_5 ::ng-deep.ck-content blockquote.side-quote {
  font-family: "Oswald";
  font-style: normal;
  float: right;
  width: 35%;
  position: relative;
  border: 0;
  overflow: visible;
  z-index: 1;
  margin-left: 1em;
}
.ckeditor_5 ::ng-deep.ck-content blockquote.side-quote::before {
  content: "“";
  position: absolute;
  top: -37px;
  left: -10px;
  display: block;
  font-size: 200px;
  color: #e7e7e7;
  z-index: -1;
  line-height: 1;
}
.ckeditor_5 ::ng-deep.ck-content blockquote.side-quote p {
  font-size: 2em;
  line-height: 1;
}
.ckeditor_5 ::ng-deep.ck-content blockquote.side-quote p:last-child:not(:first-child) {
  font-size: 1.3em;
  text-align: right;
  color: #555;
}
.ckeditor_5 ::ng-deep.ck-content span.marker {
  background: yellow;
}
.ckeditor_5 ::ng-deep.ck-content span.spoiler {
  background: #000;
  color: #000;
}
.ckeditor_5 ::ng-deep.ck-content span.spoiler:hover {
  background: #000;
  color: #fff;
}
.ckeditor_5 ::ng-deep.ck-content pre.fancy-code {
  border: 0;
  margin-left: 2em;
  margin-right: 2em;
  border-radius: 10px;
}
.ckeditor_5 ::ng-deep.ck-content pre.fancy-code::before {
  content: "";
  display: block;
  height: 13px;
  background: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NCAxMyI+CiAgPGNpcmNsZSBjeD0iNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGMzZCNUMiLz4KICA8Y2lyY2xlIGN4PSIyNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGOUJFNEQiLz4KICA8Y2lyY2xlIGN4PSI0Ny41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiM1NkM0NTMiLz4KPC9zdmc+Cg==);
  margin-bottom: 8px;
  background-repeat: no-repeat;
}
.ckeditor_5 ::ng-deep.ck-content pre.fancy-code-dark {
  background: #272822;
  color: #fff;
  box-shadow: 5px 5px 0 rgba(0, 0, 0, 0.1215686275);
}
.ckeditor_5 ::ng-deep.ck-content pre.fancy-code-bright {
  background: #dddfe0;
  color: #000;
  box-shadow: 5px 5px 0 #b3b3b3;
}

bs-datepicker-container {
  position: relative;
  z-index: 9999999;
}`, "",{"version":3,"sources":["webpack://./src/app/components/admin-single-learner-map/admin-single-learner-map.component.scss","webpack://./src/assets/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACgIhB;EACE,eAAA;AD3HF;;AC8HA;EACE,aAAA;EACA,eAAA;AD3HF;;AC8HA;EACE,sBAAA;AD3HF;;AC8HA;EACE,8BAAA;AD3HF;;AC8HA;EACE,gBAAA;AD3HF;;AC8HA;EACE,gBAAA;AD3HF;;AC8HA;EACE,aAAA;AD3HF;;AC8HA;EACE,gBAAA;AD3HF;;ACyIE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ADtIJ;ACwII;;;;;;EACE,gBAAA;ADjIN;ACqIE;;EAEE,eA5GO;EA6GP,gBA3GO;ADxBX;ACqII;EALF;;IAMI,eA/GY;EDlBhB;AACF;ACoIE;;EAEE,eAlHO;EAmHP,gBAjHO;ADjBX;ACoII;EALF;;IAMI,eArHY;EDXhB;AACF;ACmIE;;EAEE,eAxHO;EAyHP,gBAvHO;ADVX;ACmII;EALF;;IAMI,eA3HY;EDJhB;AACF;ACkIE;;EAEE,eA9HO;EA+HP,gBA7HO;ADHX;ACmIE;;EAEE,eAhIO;EAiIP,gBAhIO;ADDX;ACoIE;;EAEE,eAnIO;EAoIP,gBAnIO;ADCX;ACwIE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ADtIJ;ACwII;EACE,gBAAA;ADtIN;ACyII;EAXF;IAYI,eAAA;EDtIJ;AACF;ACyIE;;EAEE,UAAA;EACA,SAAA;ADvIJ;AC0IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ADxIJ;;AC4IA;EACE,sBAxNQ;AD+EV;;AC4IA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;ADzIF;AC2IE;EALF;IAMI,cAAA;EDxIF;AACF;AC0IE;EACE,iBA1Ka;ADkCjB;AC2IE;EACE,gBApLa;EAqLb,WAAA;ADzIJ;;AC8IE;EACE,kBAAA;AD3IJ;AC8IE;EACE,iBAAA;AD5IJ;;ACiJE;EACE,aAAA;AD9IJ;;ACkJA;EACE,kBAAA;AD/IF;ACiJE;EACE,mBAAA;AD/IJ;ACmJI;EACE,sBAAA;ADjJN;ACqJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;AD2EnB;ACqJI;EACE,sBAAA;ADnJN;ACsJI;EAVF;IAWI,eApOoB;EDiFxB;AACF;ACsJE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ADpJJ;ACsJI;EACE,sBAAA;ADpJN;ACuJI;EACE,WAAA;ADrJN;ACwJI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ADsMZ;;AC2JA;EACE,mBA1PO;ADkGT;AC0JE;EAHF;IAII,mBAAA;EDvJF;AACF;ACyJE;EACE,mBAAA;ADvJJ;AC0JE;EACE,aArQK;AD6GT;AC0JI;EAHF;IAII,aAAA;EDvJJ;AACF;ACyJI;EACE,aAAA;ADvJN;;AC4JA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;ADzJF;AC2JE;EACE,eAAA;ADzJJ;AC4JE;EACE,sCAAA;AD1JJ;AC6JE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AD3JJ;;AC0KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ADvKJ;ACyKI;EACE,kBAAA;ADvKN;AC0KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ADxKN;;AC6KA;EACE,8BAAA;AD1KF;;AC6KA;EACE,8BAAA;AD1KF;;AC6KA;EACE,+BAAA;AD1KF;;AC6KA;EACE,8BAAA;AD1KF;;AC6KA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AD1KF;AC4KE;EACE,2BAAA;EACA,mBAAA;AD1KJ;AC6KE;EACE,yBAzbiB;EA0bjB,WA1aO;AD+PX;AC8KE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AD5KJ;AC+KE;EACE,yBAjckB;EAkclB,cArciB;ADwRrB;ACgLE;EACE,yBAvbS;EAwbT,WA1bO;AD4QX;ACgLI;EACE,6BAAA;AD9KN;;ACmLA;EACE;IACE,uBAAA;EDhLF;ECmLA;IACE,yBAAA;EDjLF;AACF;ACoLA;EACE,8BAAA;ADlLF;;ACqLA;EACE,8BAAA;ADlLF;;ACqLA;EACE,+BAAA;ADlLF;;ACqLA;EACE,8BAAA;ADlLF;;ACqLA;EACE,qBAAA;ADlLF;;ACqLA;EACE,UAAA;ADlLF;ACoLE;EACE,qBAAA;ADlLJ;;ACsLA;EACE,UAAA;ADnLF;;ACuLE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ADrLJ;ACwLM;EACE,mBAAA;ADtLR;AC2LE;EACE,2BAAA;ADzLJ;AC4LE;EACE,uBAAA;AD1LJ;AC6LE;EACE,mBAAA;AD3LJ;;ACgME;EACE,mBAAA;AD7LJ;ACgME;EACE,yBAAA;AD9LJ;ACiME;EACE,sBAAA;AD/LJ;ACkME;EACE,uBAAA;ADhMJ;ACmME;EACE,oBAAA;ADjMJ;;AA9YA;EACE,eAAA;AAiZF;;AA9YA;EACE,eAAA;AAiZF;;AA9YA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AAiZF;;AA7YA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAgZF;AA9YE;EACE,yBAAA;AAgZJ;;AA5YA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AA+YF;;AA5YA;EACE,eAAA;EAEA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AA8YF;AA5YE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;AA8YJ;;AAzYA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;AA4YF;;AAzYA;EACE,aAAA;AA4YF;AA1YE;EACE,eAAA;AA4YJ;;AAxYA;EACE,cAAA;AA2YF;AAzYE;EACE,aAAA;AA2YJ;;AAvYA;EACE,kBAAA;AA0YF;;AAvYA;EACE,iBAAA;AA0YF;AAxYE;EACE,kBAAA;AA0YJ;;AAtYA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;AAyYF;AAvYE;EACE,iBAAA;EACA,WAAA;AAyYJ;;AArYA;EACE,yBAAA;EACA,2CAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAwYF;;AArYA;EACE,gBAAA;AAwYF;;AApYE;EACE,iBAAA;EACA,kBAAA;AAuYJ;;AAnYA;EACE,kBAAA;AAsYF;AApYE;EACE,kBAAA;EACA,QAAA;EACA,MAAA;AAsYJ;;AAlYA;EACE,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,qBAAA;AAqYF;AAnYE;EACE,gBAAA;EACA,6CAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAqYJ;AAlYE;EACE,eAAA;AAoYJ;AAjYM;EACE,cAAA;AAmYR;;AA5XE;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,MAAA;AA+XJ;AA7XI;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EAEA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;AA8XN;;AAzXA;EACE,eAAA;EACA,cAAA;AA4XF;;AAzXA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;AA4XF;;AAzXA;EACE,8CAAA;EACA,eAAA;AA4XF;;AAxXE;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AA2XJ;AAzXI;EACE,eAAA;EACA,6BAAA;EACA,6BAAA;EACA,oBAAA;EACA,oBAAA;EACA,cCjMe;EDkMf,gBAAA;EACA,WAAA;EACA,gBAAA;AA2XN;AAzXM;EACE,cC7LW;ADwjBnB;AAxXM;EACE,cC/LI;ADyjBZ;AAxXQ;EACE,cClME;AD4jBZ;;AAjXA;EACE,iBAAA;EACA,mCAAA;EACA,2BAAA;AAoXF;;AAjXA;EACE,aAAA;AAoXF;;AAhXE;EACE,iBAAA;EACA,WAAA;AAmXJ;;AA9WE;EACE,UAAA;AAiXJ;;AA7WA;EACE,iCAAA;EACA,sBAAA;AAgXF;;AA5WE;EACE,eAAA;AA+WJ;;AA3WA;EACE,YAAA;AA8WF;;AA3WA;EACE,aAAA;AA8WF;AA5WE;EACE,YAAA;EACA,WAAA;EACA,WAAA;AA8WJ;;AA1WA;EACE,cAAA;AA6WF;;AA1WA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AA6WF;AA3WE;EACE,oBAAA;EACA,YAAA;AA6WJ;AA1WE;EAEE,aAAA;AA2WJ;;AAtWE;EACE,WAAA;AAyWJ;;AArWA;EAOE,2BAAA;AAoWF;AAlWE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAoWJ;AAlWI;EACE,UAAA;EACA,WAAA;AAoWN;;AA1VA;EACE,uBAAA;EACA,6BAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AA6VF;;AA1VA;EACE,aAAA;EACA,WAAA;AA6VF;AA3VE;EACE,YAAA;EACA,kBAAA;EACA,eAAA;AA6VJ;;AAzVA;EACE,gBAAA;EACA,8BAAA;EACA,SAAA;EACA,6BAAA;AA4VF;;AAzVA;EACE,gBAAA;AA4VF;;AAzVA;EACE,eAAA;EACA,gBAAA;AA4VF;;AAzVA;EACE,qBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA4VF;;AAzVA;EAGE,UAAA;AA0VF;;AAtVE;EACE,eAAA;EACA,WAAA;AAyVJ;AAlVE;EACE,YAAA;AAoVJ;;AAhVA;EACE,0BAAA;AAmVF;;AAhVA;EACE,aAAA;EACA,eAAA;AAmVF;;AAhVA;;EAEE,aAAA;AAmVF;;AAhVA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;AAmVF;;AAvUE;EATF;IAUI,iBAAA;IACA,WAAA;IACA,gBAAA;EA2UF;AACF;;AAvUE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA0UJ;AAvUE;EACE,gBAAA;AAyUJ;;AAnUI;EACE,gBAAA;AAsUN;;AAhUE;EACE,cAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAmUJ;;AA7TE;EACE,iCAAA;AAgUJ;AA7TE;EACE,aAAA;AA+TJ;AA5TE;EACE,eAAA;EACA,cAAA;AA8TJ;;AA1TA;EACE,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,uBAAA;EACA,+BAAA;EACA,4BAAA;AA6TF;;AA1TA;EACE,uBAAA;EACA,wEAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,6CAAA;EACA,0CAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA6TF;AA3TE;EACE,aAAA;AA6TJ;AA1TE;EACE,oCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA4TJ;AA1TI;EACE,aAAA;EACA,4CAAA;AA4TN;AAxTE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA0TJ;AAxTI;EACE,aAAA;EACA,4CAAA;AA0TN;AAtTE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,+BAAA;EACA,4BAAA;AAwTJ;AAtTI;EACE,aAAA;EACA,6BAAA;AAwTN;AApTE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AAsTJ;AApTI;EACE,aAAA;EACA,6BAAA;AAsTN;AAlTE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AAoTJ;AAlTI;EACE,aAAA;EACA,6BAAA;AAoTN;;AA/SA;EACE,UAAA;EACA,8CAAA;AAkTF;;AA/SA;EACE,uBAAA;EACA,iEAAA;EACA,oCAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,qBAAA;AAkTF;;AA/SA;EACE,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,6CAAA;EACA,0CAAA;EACA,yBAAA;EACA,wBAAA;EACA,iCAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,aAAA;AAkTF;;AA9SE;EACE,eAAA;EACA,YAAA;EACA,cAAA;AAiTJ;AA/SI;EACE,eAAA;EACA,gBAAA;AAiTN;AA7SE;EACE,gBAAA;AA+SJ;;AA3SA;EACE,gBAAA;AA8SF;AA5SE;EACE,kBAAA;AA8SJ;;AA1SA;EACE,0BAAA;AA6SF;;AA1SA;EACE,aAAA;EACA,gBAAA;AA6SF;;AA1RI;EACE,UAAA;AA6RN;AAzRE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AA2RJ;AAzRI;EACE,WAAA;AA2RN;AAzRM;EACE,mBAAA;EACA,aAAA;AA2RR;AAzRQ;EACE,gBAAA;AA2RV;AAvRM;EACE,cAAA;AAyRR;AAvRQ;EACE,UAAA;EACA,WAAA;AAyRV;AAvRU;EACE,eAAA;AAyRZ;;AAjRA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAoRF;;AA/QE;EACE,cAAA;AAkRJ;AA7QI;EACE,aAAA;AA+QN;;AA1QA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AA6QF;;AAvQI;EAEE,yBAAA;EACA,kBAAA;EACA,iBAAA;AAyQN;AAtQM;EACE,UAAA;EACA,gBAAA;AAwQR;AArQM;EACE,SAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;AAuQR;;AAhQA;EACE,QAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAmQF;AAjQE;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AAmQJ;AAhQM;EACE,gCAAA;AAkQR;AAhQQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAkQV;AA/PU;EATF;IAUI,mBAAA;EAkQV;AACF;AA/PQ;EACE,UAAA;EACA,eAAA;EACA,yBAAA;AAiQV;AA9PY;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAgQd;AA7PY;EAPF;IAQI,2BAAA;EAgQZ;AACF;AA1PQ;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,eAAA;AA4PV;AA1PU;EACE,aAAA;AA4PZ;AAzPU;EACE,YAAA;AA2PZ;AAxPU;EACE,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;AA0PZ;AAtPQ;EACE,eAAA;AAwPV;AArPY;EACE,aAAA;AAuPd;AAjPU;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAmPZ;AAhPU;EACE,WAAA;AAkPZ;AA1OgB;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AA4OlB;AA1OkB;EACE,eAAA;EACA,mBAAA;AA4OpB;AAxOgB;EACE,eAAA;AA0OlB;AAnOQ;EACE,YAAA;EACA,cAAA;EACA,eAAA;AAqOV;AA/Nc;EADF;IAEI,mBAAA;EAkOd;AACF;AA9NkB;EADF;IAEI,mBAAA;EAiOlB;AACF;AA3NU;EACE,gBAAA;AA6NZ;AA3NY;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AA6Nd;AAvNM;EACE,gBAAA;EACA,6BAAA;AAyNR;AAtNU;EACE,gBAAA;AAwNZ;AAtNY;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;AAwNd;AAtNc;EALF;IAMI,eAAA;IACA,kBAAA;EAyNd;AACF;AAvNc;EAVF;IAWI,eAAA;EA0Nd;AACF;AArNY;EADF;IAEI,WAAA;EAwNZ;AACF;AArNc;EADF;IAEI,mBAAA;EAwNd;AACF;AApNU;EAhCF;IAiCI,sBAAA;IACA,uBAAA;EAuNV;AACF;AAlNI;EACE,gBAAA;AAoNN;AAjNI;EACE,gBAAA;AAmNN;AA9MI;EACE,0CAAA;AAgNN;AA5ME;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AA8MJ;AA5MI;EACE,qBAAA;EACA,yBAAA;AA8MN;AA3MI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AA6MN;AA3MM;EACE,qBAAA;EACA,yBAAA;AA6MR;AAzMI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AA2MN;AAzMM;EACE,qBAAA;EACA,yBAAA;AA2MR;AAvMI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AAyMN;AAvMM;EACE,qBAAA;EACA,yBAAA;AAyMR;AApME;EACE,UAAA;EACA,gCAAA;AAsMJ;AApMI;EACE,UAAA;AAsMN;AAlME;EACE,yBAAA;AAoMJ;AAjME;EACE,gBAAA;EACA,kBAAA;AAmMJ;AAhME;EACE,oCAAA;AAkMJ;;AA7LE;EACE,mBAAA;AAgMJ;;AA5LA;EACE,UAAA;EACA,gCAAA;AA+LF;;AA5LA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AA+LF;;AA5LA;EACE,yBAAA;AA+LF;;AA5LA;EACE,wBAAA;AA+LF;;AA5LA;EACE,+BAAA;AA+LF;;AA5LA;EACE,UAAA;AA+LF;;AA5LA;EACE,gBAAA;AA+LF;AA7LE;EACE,kBAAA;EACA,gBAAA;AA+LJ;;AA3LA;EACE,wBAAA;EACA,eAAA;EACA,QAAA;EACA,sBAAA;AA8LF;AA5LE;EACE,wBAAA;EACA,UAAA;AA8LJ;;AA1LA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,cAAA;AA6LF;AA3LE;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AA6LN;AA1LE;EACI,kBAAA;EACA,wCAAA;AA4LN;AA1LM;EACI,wBAAA;AA4LV;AAzLM;EACI,wBAAA;AA2LV;AAvLQ;EACE,uBAAA;AAyLV;AAtLQ;EACI,uBAAA;AAwLZ;AAnLQ;EACE,uBAAA;AAqLV;AAlLQ;EACI,uBAAA;AAoLZ;AA/KE;EACI,kBAAA;EACA,6BAAA;EACA,kBAAA;AAiLN;AA/KM;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAiLV;AA7KE;EACI,0BAAA;AA+KN;AA1KM;EACI,gBAAA;AA4KV;AAzKM;EACI,eAAA;AA2KV;AAvKE;EACI,eAAA;EACA,gBAAA;AAyKN;AAtKE;EACI,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAwKN;AAtKM;EACI,gBAAA;AAwKV;AApKE;;EAEI,YAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;AAsKN;AApKM;;EACI,aAAA;AAuKV;AAnKE;EACI,iBAAA;EACA,kBAAA;EACA,QAAA;AAqKN;AAlKE;EAEI,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,SAAA;AAmKN;AA/JU;EACI,0BAAA;EACA,oCAAA;EACA,gBAAA;AAiKd;AA5JE;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA8JN;AA5JM;EACI,YAAA;AA8JV;AA3JM;EAEI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,+CAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AA4JV;AAzJM;EACI,8CAAA;AA2JV;;AAtJA;EACE,yBAAA;EACA,2BAAA;EACA,+BAAA;AAyJF;;AAtJA;EACE,iBAAA;EACA,2BAAA;EACA,8BAAA;EACA,+BAAA;EACA,wBAAA;EACA,gCAAA;AAyJF;;AAtJA;EACE,eAAA;AAyJF;;AAtJA;EACE,mBAAA;AAyJF;;AAtJA;EACE,qBAAA;AAyJF;;AAlJE;EACE,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAqJJ;AAlJE;EACE,mBAAA;EACA,gBAAA;EACA,sBAAA;AAoJJ;AAjJE;EACE,gBAAA;EACA,gBAAA;AAmJJ;AAhJE;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;EACA,UAAA;AAkJJ;AA/IE;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AAiJJ;AA9IE;EACE,qBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AAgJJ;AA7IE;EACE,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,yCAAA;EACA,mTAAA;EAYA,mBAAA;EACA,iBAAA;EACA,6BAAA;AAoIJ;AAjIE;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;AAmIJ;AAhIE;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;AAkIJ;AA/HE;EACE,cAAA;EACA,cAAA;AAiIJ;AA9HE;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;AAgIJ;AA7HE;EACE,kBAAA;AA+HJ;AA5HE;EACE,gBAAA;EACA,WAAA;AA8HJ;AA3HE;EACE,gBAAA;EACA,WAAA;AA6HJ;AA1HE;EACE,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AA4HJ;AAzHE;EACE,WAAA;EACA,cAAA;EACA,YAAA;EACA,+WAAA;EACA,kBAAA;EACA,4BAAA;AA2HJ;AAxHE;EACE,mBAAA;EACA,WAAA;EACA,iDAAA;AA0HJ;AAvHE;EACE,mBAAA;EACA,WAAA;EACA,6BAAA;AAyHJ;;AApHA;EACI,kBAAA;EACA,gBAAA;AAuHJ","sourcesContent":["@import './../../../assets/styles/variables';\n@import 'ckeditor5/ckeditor5.css';\n@import url('https://fonts.googleapis.com/css2?family=Oswald&family=PT+Serif:ital,wght@0,400;0,700;1,400&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap');\n\nh2 {\n  font-size: 24px;\n}\n\nbody {\n  font-size: 13px;\n}\n\n.list-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #333;\n  padding: 16px;\n  margin-top: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 80%;\n  margin-bottom: 10px;\n}\n\n\n.fixed-loader {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n\n  i {\n    font-size: 8em !important;\n  }\n}\n\n.list-items {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-content: flex-start;\n  padding: 0 10px 6px;\n}\n\n.list {\n  flex: 0 0 27rem;\n  //flex: 0 0 27rem;\n  display: flex;\n  flex-direction: column;\n  background-color: #e2e4e6;\n  border-radius: 4px;\n  position: relative;\n\n  div#move-member {\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n\n}\n\n.list-items li {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 1.3;\n  background-color: #fff;\n  padding: 10px 9px;\n  color: #4d4d4d;\n  border-bottom: 2px solid #ccc;\n  border-radius: 4px;\n  margin-bottom: 9px;\n  word-wrap: break-word;\n  cursor: pointer;\n}\n\n.list-columns {\n  display: flex;\n\n  div {\n    cursor: pointer;\n  }\n}\n\n.table-responsive {\n  overflow: auto;\n\n  &--height {\n    height: 100vh;\n  }\n}\n\n.p-l-25 {\n  padding-left: 25px;\n}\n\n.add-card-btn {\n  padding-top: 10px;\n\n  & span {\n    padding-left: 10px;\n  }\n}\n\n.update-card-btn {\n  margin-left: auto;\n  margin-bottom: 16px;\n  padding-left: 10px;\n\n  & a {\n    margin-left: 20px;\n    color: #fff;\n  }\n}\n\n.button-link {\n  background-color: #ebecf0;\n  box-shadow: 0 1px 0 0 rgba(9, 30, 66, .13);\n  border: none;\n  border-radius: 3px;\n  display: block;\n  font-weight: 700;\n  height: 32px;\n  margin-top: 8px;\n  max-width: 300px;\n  padding: 3px 12px;\n}\n\n.title-icon {\n  content: \"\\E968\";\n}\n\n.list-columns {\n  div[class*=\"col-\"] {\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n}\n\n.option-menu {\n  position: relative;\n\n  .list-action-dropdown {\n    position: absolute;\n    right: 0;\n    top: 0;\n  }\n}\n\n.column-edit {\n  cursor: pointer;\n  padding: 6px 12px;\n  border: 1px solid transparent;\n  display: inline-block;\n\n  &::before {\n    content: \"\\f142\";\n    font: normal normal normal 14px / 1 FontAwesome;\n    font-size: 15px;\n    color: #b7b7b7;\n    line-height: 3px;\n    cursor: pointer;\n  }\n\n  &.dropdown {\n    cursor: pointer;\n\n    &:hover {\n      .dropdown__list {\n        display: block;\n      }\n    }\n  }\n}\n\n.quick-card-editor-buttons {\n  .subgroup-move {\n    display: block;\n    position: absolute;\n    right: 5px;\n    background: rgba(0, 0, 0, .7);\n    border-radius: 5px;\n    z-index: 99;\n    display: none;\n    top: 0;\n\n    .subgroup-inner {\n      background: #fff;\n      position: absolute;\n      right: 0;\n      // padding: 20px 20px 15px;\n      border-radius: 4px;\n      top: 100%;\n      min-width: 150px;\n      box-shadow: 1px 10px 29px rgba(0, 0, 0, 0.1);\n      top: 28px;\n    }\n  }\n}\n\n.close-action {\n  cursor: pointer;\n  color: #212529;\n}\n\n.card-title {\n  color: #333;\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n\n.column-actions {\n  border-bottom: 1px solid rgba(9, 30, 66, .13);\n  font-size: 16px;\n}\n\n.list-actions {\n  button {\n    font-size: 13px;\n    border: none;\n    padding: 6px 12px;\n    cursor: pointer;\n\n    &.modify {\n      cursor: pointer;\n      background-color: transparent;\n      border-top: 1px solid $color-grey-1;\n      border-radius: unset;\n      padding-inline: 20px;\n      color: $body-content-color;\n      font-weight: 600;\n      width: 100%;\n      text-align: left;\n\n      &:hover {\n        color: $color-dark-green;\n      }\n\n      &--red {\n        color: $color-red;\n\n        &:hover {\n          color: $color-red;\n        }\n\n      }\n    }\n\n  }\n}\n\n.image-imitation {\n  min-height: 400px;\n  background-size: contain !important;\n  background-position: center;\n}\n\n.ibox-content.pos-relative {\n  padding: 30px;\n}\n\n::ng-deep.modal-module {\n  .modal-dialog {\n    max-width: 1170px;\n    width: 100%;\n  }\n}\n\n::ng-deep.ngx-datepicker-container {\n  .ngx-datepicker-calendar-container {\n    z-index: 9;\n  }\n}\n\n::ng-deep.ngx-datepicker-input {\n  background-color: #fff !important;\n  width: 100% !important;\n}\n\n.card-actions {\n  a {\n    display: inline;\n  }\n}\n\n.action-icons {\n  padding: 0px;\n}\n\n.session-btn {\n  display: flex;\n\n  a {\n    padding: 5px;\n    width: 26px;\n    color: #fff;\n  }\n}\n\n.top-session-grid {\n  margin: 10px 0;\n}\n\n.form-control {\n  border: 1px solid #7b7b7b;\n  border-radius: 4px;\n  font: inherit;\n  min-height: 34px;\n\n  &__disabled {\n    pointer-events: none;\n    opacity: 0.6;\n  }\n\n  &:focus-visible,\n  &:focus {\n    outline: none;\n  }\n}\n\n.card-actions {\n  a {\n    color: #fff;\n  }\n}\n\n.custom-modal-footer {\n  //justify-content: end;\n  //-webkit-justify-content: end;\n  //-moz-justify-content: end;\n\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n\n  .form-group {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n\n    label {\n      padding: 0;\n      width: auto;\n    }\n  }\n}\n\n.modal-footer-main {\n  // padding-left: 15px;\n  // padding-right: 15px;\n}\n\n.add-card-btn.btn {\n  background: transparent;\n  border: 1px solid transparent;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.list-columns .input-group {\n  display: flex;\n  width: 100%;\n\n  .f-btn {\n    height: 100%;\n    min-width: 91.55px;\n    font-size: 14px;\n  }\n}\n\nhr {\n  margin-top: 20px;\n  margin-bottom: 20px !important;\n  border: 0;\n  border-top: 1px solid #eeeeee;\n}\n\n.mt-3.btn-primary {\n  margin-top: 10px;\n}\n\n.col-sm-3 {\n  flex: 0 0 290px;\n  max-width: 290px;\n}\n\n.modal-title {\n  display: inline-block;\n  font-size: 20px;\n  color: #212529;\n  font-weight: 500;\n}\n\n.modal-header .close {\n  // padding: 16px 32px;\n  // margin: -16px -16px -16px auto;\n  opacity: 1;\n}\n\n.modal-header .close {\n  .btn {\n    font-size: 14px;\n    margin: 1px;\n    // opacity:0.5;\n    // &:hover, &:focus{\n    //     opacity:1;\n    // }\n  }\n\n  .btn-warning {\n    margin: 10px;\n  }\n}\n\n.modal-footer {\n  border-top: 1px solid #ddd;\n}\n\n.modal-footer.custom-modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.modal-footer.custom-modal-footer:before,\n.modal-footer.custom-modal-footer:after {\n  display: none;\n}\n\n.modal-footer.custom-modal-footer h2 {\n  font-weight: 500;\n  color: #6c757d !important;\n  margin-bottom: 8px;\n}\n\n.modal-footer .form-group {\n  // padding-left: 0px;\n\n  &+.form-group {\n    @media(min-width:768px) {\n      // padding-left: 25px;\n    }\n  }\n\n  @media (max-width:767px) {\n    padding-left: 0px;\n    width: 100%;\n    text-align: left;\n  }\n}\n\n.modal-copy {\n  h3 {\n    font-size: 24px;\n    color: #333;\n    font-weight: 500;\n    margin-left: -15px;\n    margin-right: -15px;\n  }\n\n  .btn-primary {\n    margin-top: 15px;\n  }\n}\n\n.card-body {\n  &+ {\n    .card-body .card-title {\n      margin-top: 15px;\n    }\n  }\n}\n\n::ng-deep.single-card-link {\n  span {\n    display: block;\n    font-size: 65%;\n    text-transform: uppercase;\n    padding-top: 8px;\n  }\n}\n\n::ng-deep.list-group-item {\n\n  &--inactive {\n    background-color: #ccc !important;\n  }\n\n  span {\n    display: none;\n  }\n\n  div {\n    font-size: 11px;\n    display: block;\n  }\n}\n\n::ng-deep.swal2-modal {\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  -moz-flex-wrap: wrap;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -moz-justify-content: center;\n}\n\n::ng-deep .swal2-show {\n  background-color: white;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  width: 478px;\n  padding: 17px;\n  border-radius: 5px;\n  text-align: center;\n  position: fixed;\n  left: 0 !important;\n  top: 0 !important;\n  transform: translate(0, 0) !important;\n  -webkit-transform: translate(0, 0) !important;\n  -moz-transform: translate(0, 0) !important;\n  margin-left: -256px;\n  overflow: hidden;\n  z-index: 99999;\n  margin-top: -168px;\n\n  &:focus {\n    outline: none;\n  }\n\n  button.swal2-cancel.swal2-styled {\n    background-color: #28a745 !important;\n    color: white;\n    border: none;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    -webkit-border-radius: 4px;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 26px 5px 0 5px;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.5);\n    }\n  }\n\n  button.swal2-confirm.swal2-styled {\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    -webkit-border-radius: 4px;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 26px 5px 0 5px;\n    cursor: pointer;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(220, 53, 58, 0.5);\n    }\n  }\n\n  .swal2-icon.swal2-warning {\n    width: 80px;\n    height: 80px;\n    border: 4px solid gray;\n    -webkit-border-radius: 40px;\n    border-radius: 40px;\n    border-radius: 50%;\n    margin: 20px auto;\n    padding: 0;\n    position: relative;\n    box-sizing: content-box;\n    border-color: #F8BB86;\n    font-size: 58px;\n    color: #F8BB86;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -moz-justify-content: center;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px #F8BB86;\n    }\n  }\n\n  h2#swal2-title {\n    color: #575757;\n    font-size: 30px;\n    text-align: center;\n    font-weight: 600;\n    text-transform: none;\n    position: relative;\n    margin: 25px 0;\n    padding: 0;\n    line-height: 40px;\n    display: block;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px #575757;\n    }\n  }\n\n  div#swal2-content {\n    color: #797979;\n    font-size: 16px;\n    text-align: center;\n    font-weight: 300;\n    position: relative;\n    text-align: inherit;\n    float: none;\n    margin: 0;\n    padding: 0;\n    line-height: normal;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px #797979;\n    }\n  }\n}\n\n.swal2-show button.swal2-cancel.swal2-styled:focus {\n  opacity: 1;\n  box-shadow: 0 0 0 3px rgba(208, 208, 208, .5);\n}\n\n::ng-deep .swal2-shown {\n  background-color: black;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)\";\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 999999999999;\n}\n\n::ng-deep.swal2-modal {\n  max-width: 500px !important;\n  width: 100% !important;\n  left: 0 !important;\n  top: 0 !important;\n  transform: translate(0, 0) !important;\n  -webkit-transform: translate(0, 0) !important;\n  -moz-transform: translate(0, 0) !important;\n  margin-left: 0 !important;\n  margin-top: 0 !important;\n  box-sizing: border-box !important;\n  bottom: 0;\n  right: 0;\n  margin: auto !important;\n  height: 390px;\n}\n\n.modal-body {\n  .ibox-title {\n    padding-left: 0;\n    border: none;\n    padding-top: 0;\n\n    h5 {\n      font-size: 17px;\n      font-weight: 500;\n    }\n  }\n\n  .btn.btn-primary {\n    margin-top: 18px;\n  }\n}\n\n.edit-lm {\n  margin-top: 25px;\n\n  a {\n    margin-right: 10px;\n  }\n}\n\n.card-active {\n  text-transform: capitalize;\n}\n\n.video-info {\n  padding: 15px;\n  margin-top: 40px;\n}\n\n.edit-card {\n\n  &__top {\n\n    .col-form-label {\n      // width: 25%;\n    }\n  }\n\n  &__right {\n    // width: 65%;\n\n    .col-form-label {\n      // width: 15%;\n    }\n\n    .col-md-9 {\n      width: 85%;\n    }\n  }\n\n  &__btm {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-block: 25px;\n    flex-direction: column-reverse;\n\n    .editor-script {\n      width: 100%;\n\n      &--spc {\n        margin-bottom: 15px;\n        display: none;\n\n        .editor-script {\n          margin-top: 25px;\n        }\n      }\n\n      &--visible {\n        display: block;\n\n        label {\n          padding: 0;\n          width: 100%;\n\n          i {\n            cursor: pointer;\n          }\n        }\n      }\n    }\n  }\n}\n\n.feature-grp {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.middle-grid {\n\n  .cdkeditmode {\n    display: block;\n  }\n\n  &--show-editor {\n\n    .cdkeditmode {\n      display: none;\n    }\n  }\n}\n\n.cdk-drag-outer {\n  flex: 0 0 225px;\n  max-width: 225px;\n  float: none;\n}\n\n::ng-deep {\n  bs-datepicker {\n\n    &#first-train,\n    &#last-train {\n      border: 1px solid #7b7b7b;\n      border-radius: 4px;\n      padding: 6px 12px;\n\n\n      .datepicker-container {\n        width: 94%;\n        padding-top: 7px;\n      }\n\n      input {\n        border: 0;\n        font-family: 'Open Sans';\n        color: #676a6c;\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n// Modal Styling\n::ng-deep .modal {\n  inset: 0;\n  outline: 0;\n  z-index: 1050;\n  display: none;\n  position: fixed;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n\n  .modal-dialog {\n    width: 100%;\n    padding: 0 15px;\n    max-width: 1200px;\n    margin: 30px auto;\n\n    .modal-content {\n      .modal-header {\n        border-bottom: 1px solid #e5e5e5;\n\n        .modal-title {\n          margin: 0;\n          font-size: 20px;\n          font-weight: 500;\n          line-height: 1.5;\n          color: #212529;\n          display: inline-block;\n\n\n          @media (max-width: 767px) {\n            margin-bottom: 15px;\n          }\n        }\n\n        .close {\n          opacity: 1;\n          font-size: 21px;\n          text-shadow: 0 1px 0 #fff;\n\n          .actn {\n            &__btn {\n              width: 35px;\n              height: 32px;\n              padding: 3px;\n            }\n\n            @media (max-width: 767px) {\n              justify-content: flex-start;\n            }\n          }\n        }\n      }\n\n      .modal-body {\n        .close {\n          float: right;\n          border: none;\n          opacity: 0.2;\n          color: #000;\n          line-height: 1;\n          font-size: 21px;\n          font-weight: bold;\n          background-color: #fff;\n          filter: alpha(opacity=20);\n          text-shadow: 0 1px 0 #fff;\n          cursor: pointer;\n\n          &:focus-visible {\n            outline: none;\n          }\n\n          &:hover {\n            opacity: 0.5;\n          }\n\n          &.button {\n            border: 0;\n            padding: 0;\n            cursor: pointer;\n            appearance: none;\n            background: transparent;\n            -webkit-appearance: none;\n          }\n        }\n\n        .small {\n          font-size: 12px;\n\n          a {\n            &:focus-visible {\n              outline: none;\n            }\n          }\n        }\n\n        &.modal-copy {\n          h3 {\n            color: #333;\n            font-size: 24px;\n            font-weight: 500;\n            margin-left: -15px;\n            margin-right: -15px;\n          }\n\n          .card-body {\n            width: 100%;\n          }\n        }\n\n        .top-form {\n          .edit-card {\n            &__top {\n              .media-content {\n                h2 {\n                  font-size: 24px;\n                  font-weight: 600;\n                  margin-bottom: 5px;\n\n                  small {\n                    font-size: 16px;\n                    font-weight: normal;\n                  }\n                }\n\n                .single-card-link {\n                  cursor: pointer;\n                }\n              }\n            }\n          }\n        }\n\n        .ibox-title {\n          border: none;\n          padding-top: 0;\n          padding-left: 0;\n        }\n\n        form {\n          .rw {\n            &__cl:not(:last-child) {\n              @media (max-width: 767px) {\n                margin-bottom: 15px;\n              }\n\n              .rw-lvl-2 {\n                &__cl:not(:last-child) {\n                  @media (max-width: 767px) {\n                    margin-bottom: 15px;\n                  }\n                }\n              }\n            }\n          }\n\n          .form-group {\n            margin-bottom: 0;\n\n            label {\n              max-width: 100%;\n              font-weight: 700;\n              display: inline-block;\n            }\n          }\n        }\n      }\n\n      .modal-footer {\n        text-align: left;\n        border-top: 1px solid #e5e5e5;\n\n        &__cntnt {\n          .form-group {\n            margin-bottom: 0;\n\n            h2 {\n              margin-bottom: 20px;\n              font-weight: 500;\n              color: #6c757d !important;\n\n              @media (max-width: 1200px) {\n                font-size: 16px;\n                margin-block: 12px;\n              }\n\n              @media (max-width: 991px) {\n                margin-block: 0;\n              }\n            }\n          }\n\n          &>* {\n            @media (max-width: 991px) {\n              width: 100%;\n            }\n\n            &:not(:last-child) {\n              @media (max-width: 991px) {\n                margin-bottom: 15px;\n              }\n            }\n          }\n\n          @media (max-width: 991px) {\n            flex-direction: column;\n            align-items: flex-start;\n          }\n        }\n      }\n    }\n\n    &.modal-sm {\n      max-width: 300px;\n    }\n\n    &.modal-lg {\n      max-width: 900px;\n    }\n  }\n\n  &Parent {\n    &.grey {\n      background-color: rgba(236, 236, 236, .9);\n    }\n  }\n\n  .f-btn {\n    color: #fff;\n    font-size: 14px;\n    border-color: #73BF38;\n    background-color: #73BF38;\n\n    &:hover {\n      border-color: #4cae4c;\n      background-color: #4cae4c;\n    }\n\n    &--dngr {\n      color: #fff;\n      border-color: #ED5565;\n      background-color: #ED5565;\n\n      &:hover {\n        border-color: #ec4758;\n        background-color: #ec4758;\n      }\n    }\n\n    &--info {\n      color: #fff;\n      border-color: #23c6c8;\n      background-color: #23c6c8;\n\n      &:hover {\n        border-color: #21b9bb;\n        background-color: #21b9bb;\n      }\n    }\n\n    &--wrng {\n      color: #fff;\n      border-color: #f8ac59;\n      background-color: #f8ac59;\n\n      &:hover {\n        border-color: #f7a54a;\n        background-color: #f7a54a;\n      }\n    }\n  }\n\n  &.fade {\n    opacity: 0;\n    transition: opacity .15s linear;\n\n    &.in {\n      opacity: 1;\n    }\n  }\n\n  &.show {\n    display: block !important;\n  }\n\n  &.modal-open {\n    overflow-y: auto;\n    overflow-x: hidden;\n  }\n\n  &.grey {\n    background: rgba(236, 236, 236, .9);\n  }\n}\n\n::ng-deep {\n  .swal2-container {\n    z-index: 9999999999;\n  }\n}\n\n.fade {\n  opacity: 0;\n  transition: opacity .15s linear;\n}\n\n.modal {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n}\n\n.show {\n  display: block !important;\n}\n\n.modal {\n  z-index: 2050 !important;\n}\n\n.modal {\n  z-index: 20509999999 !important;\n}\n\n.fade.in {\n  opacity: 1;\n}\n\n::ng-deep body.modal-open {\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n.modal-backdrop {\n  z-index: 2040 !important;\n  position: fixed;\n  inset: 0;\n  background-color: #000;\n\n  &.fade {\n    filter: alpha(opacity=0);\n    opacity: 0;\n  }\n}\n\n.dialogbox {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgb(236 236 236 / 90%);\n  z-index: 99999;\n\n  &__wrapper {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      width: 100%;\n      height: 100%;\n      overflow-y: auto;\n      padding: 30px;\n  }\n\n  &__inner {\n      border-radius: 4px;\n      box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n\n      &[data-width=\"small\"] {\n          width: min(1090px, 100%);\n      }\n\n      &[data-width=\"medium\"] {\n          width: min(1198px, 100%);\n      }\n\n      &--wd {\n        &[data-width=\"small\"] {\n          width: min(770px, 100%);\n        }\n\n        &[data-width=\"medium\"] {\n            width: min(870px, 100%);\n        }\n      }\n      \n      &--clwid {\n        &[data-width=\"small\"] {\n          width: min(170px, 100%);\n        }\n\n        &[data-width=\"medium\"] {\n            width: min(270px, 100%);\n        }\n      }\n  }\n\n  &__hdr {\n      padding: 15px 30px;\n      border-bottom: 1px solid $clrDarkGray1;\n      position: relative;\n\n      h2 {\n          font-size: 17px;\n          line-height: 1.3;\n          font-weight: 400;\n      }\n  }\n\n  &__ftr {\n      border-top: 1px solid $clrDarkGray1;\n  }\n\n  .dialogbox__steps {\n\n      :is(ul, ol):last-child {\n          margin-bottom: 0;\n      }\n\n      li {\n          font-size: 12px;\n      }\n  }\n\n  &__smalllabel {\n      font-size: 12px;\n      font-weight: 400;\n  }\n\n  label {\n      display: inline-block;\n      max-width: 100%;\n      margin-bottom: 15px;\n      font-weight: 700;\n      margin-top: 0;\n\n      &:last-child {\n          margin-bottom: 0;\n      }\n  }\n\n  select,\n  input[type=\"text\"] {\n      height: 35px;\n      padding: 3px 10px;\n      width: 100%;\n      background-color: #fff;\n      border: 1px solid $clrDarkGray1;\n\n      &:focus {\n          outline: none;\n      }\n  }\n\n  input[type=\"radio\"] {\n      margin: 0 5px 0 0;\n      position: relative;\n      top: 2px;\n  }\n\n  &__dpsteps {\n\n      counter-reset: section;\n      list-style-type: none;\n      padding: 0;\n      margin: 0;\n\n      &-hdr {\n\n          &::before {\n              counter-increment: section;\n              content: counters(section, \".\") \". \";\n              font-weight: 700;\n          }\n      }\n  }\n\n  &__close {\n      --cSize: 16px;\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      right: 15px;\n      width: var(--cSize);\n      height: var(--cSize);\n      padding: 0;\n      border: 0;\n      background-color: transparent;\n      opacity: 0.2;\n      transition: 0.3s;\n      cursor: pointer;\n\n      &:hover {\n          opacity: 0.4;\n      }\n\n      &::before,\n      &::after {\n          content: \"\";\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%) rotate(-45deg);\n          width: 2px;\n          height: 100%;\n          background-color: #000;\n          border-radius: 2px;\n      }\n\n      &::after {\n          transform: translate(-50%, -50%) rotate(45deg);\n      }\n  }\n}\n\n::ng-deep.NgxEditor__MenuBar {\n  border: 1px solid $color-grey-1;\n  border-top-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n::ng-deep.NgxEditor {\n  min-height: 200px;\n  border-radius: 0 !important;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-top: 0 !important;\n  border-color: $color-grey-1 !important;\n}\n\n::ng-deep bs-datepicker-container {\n  z-index: 999999;\n}\n\n::ng-deep code {\n  white-space: normal;\n}\n\n.wrd-break {\n  word-wrap: break-word;\n}\n\n\n\n// ck editor \n.ckeditor_5 {\n  ::ng-deep.main-container {\n    font-family: 'Lato';\n    width: fit-content;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  ::ng-deep.ck-content {\n    font-family: 'Lato';\n    line-height: 1.6;\n    word-break: break-word;\n  }\n  \n  ::ng-deep.editor-container_classic-editor .editor-container__editor {\n    min-width: 795px;\n    max-width: 795px;\n  }\n  \n  ::ng-deep.ck-content h3.category {\n    font-family: 'Oswald';\n    font-size: 20px;\n    font-weight: bold;\n    color: #555;\n    letter-spacing: 10px;\n    margin: 0;\n    padding: 0;\n  }\n  \n  ::ng-deep.ck-content h2.document-title {\n    font-family: 'Oswald';\n    font-size: 50px;\n    font-weight: bold;\n    margin: 0;\n    padding: 0;\n    border: 0;\n  }\n  \n  ::ng-deep.ck-content h3.document-subtitle {\n    font-family: 'Oswald';\n    font-size: 20px;\n    color: #555;\n    margin: 0 0 1em;\n    font-weight: bold;\n    padding: 0;\n  }\n  \n  ::ng-deep.ck-content p.info-box {\n    --background-size: 30px;\n    --background-color: #e91e63;\n    padding: 1.2em 2em;\n    border: 1px solid var(--background-color);\n    background: linear-gradient(\n        135deg,\n        var(--background-color) 0%,\n        var(--background-color) var(--background-size),\n        transparent var(--background-size)\n      ),\n      linear-gradient(\n        135deg,\n        transparent calc(100% - var(--background-size)),\n        var(--background-color) calc(100% - var(--background-size)),\n        var(--background-color)\n      );\n    border-radius: 10px;\n    margin: 1.5em 2em;\n    box-shadow: 5px 5px 0 #ffe6ef;\n  }\n  \n  ::ng-deep.ck-content blockquote.side-quote {\n    font-family: 'Oswald';\n    font-style: normal;\n    float: right;\n    width: 35%;\n    position: relative;\n    border: 0;\n    overflow: visible;\n    z-index: 1;\n    margin-left: 1em;\n  }\n  \n  ::ng-deep.ck-content blockquote.side-quote::before {\n    content: '“';\n    position: absolute;\n    top: -37px;\n    left: -10px;\n    display: block;\n    font-size: 200px;\n    color: #e7e7e7;\n    z-index: -1;\n    line-height: 1;\n  }\n  \n  ::ng-deep.ck-content blockquote.side-quote p {\n    font-size: 2em;\n    line-height: 1;\n  }\n  \n  ::ng-deep.ck-content blockquote.side-quote p:last-child:not(:first-child) {\n    font-size: 1.3em;\n    text-align: right;\n    color: #555;\n  }\n  \n  ::ng-deep.ck-content span.marker {\n    background: yellow;\n  }\n  \n  ::ng-deep.ck-content span.spoiler {\n    background: #000;\n    color: #000;\n  }\n  \n  ::ng-deep.ck-content span.spoiler:hover {\n    background: #000;\n    color: #fff;\n  }\n  \n  ::ng-deep.ck-content pre.fancy-code {\n    border: 0;\n    margin-left: 2em;\n    margin-right: 2em;\n    border-radius: 10px;\n  }\n  \n  ::ng-deep.ck-content pre.fancy-code::before {\n    content: '';\n    display: block;\n    height: 13px;\n    background: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NCAxMyI+CiAgPGNpcmNsZSBjeD0iNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGMzZCNUMiLz4KICA8Y2lyY2xlIGN4PSIyNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGOUJFNEQiLz4KICA8Y2lyY2xlIGN4PSI0Ny41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiM1NkM0NTMiLz4KPC9zdmc+Cg==);\n    margin-bottom: 8px;\n    background-repeat: no-repeat;\n  }\n  \n  ::ng-deep.ck-content pre.fancy-code-dark {\n    background: #272822;\n    color: #fff;\n    box-shadow: 5px 5px 0 #0000001f;\n  }\n  \n  ::ng-deep.ck-content pre.fancy-code-bright {\n    background: #dddfe0;\n    color: #000;\n    box-shadow: 5px 5px 0 #b3b3b3;\n  }\n\n}\n\nbs-datepicker-container {\n    position: relative;\n    z-index: 9999999;\n}\n\n","// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
